export default "/images/23b08c0a32010d1481c3e8b44996d6df.avif";